module.exports = __webpack_public_path__ + "img/LV_2b_blanc.e8e66d8e.png";